var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIconStarCircleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M8.48151 4.539C8.64072 4.05537 9.33885 4.05357 9.50053 4.53654L10.4255 7.30045L13.3949 7.2928C13.9139 7.29131 14.1314 7.9415 13.7123 8.24146L11.3146 9.95708L12.2396 12.7209C12.4013 13.2041 11.8371 13.6076 11.4166 13.3097L9.00983 11.6063L6.61215 13.3218C6.19311 13.6218 5.62681 13.2212 5.78606 12.7375L6.69637 9.96881L4.28943 8.26542C3.86873 7.96784 4.08275 7.31665 4.60173 7.31517L7.57117 7.30776L8.48151 4.539Z"
  })));
}
export default SvgBookmarkIconStarCircleSmall;